export default __webpack_public_path__ + "static/media/anete-lusina-rFKBUwLg_WQ-unsplash@2x.90f3f9ab.png";